import { Card } from '@/components/ui/card';
import { Recommendation } from '@repo/types/src/recommendation';
import { DeleteRecommendation } from './DeleteRecommendation';
import { EditRecommendation } from './EditRecommendation';

type RecommendationCardProps = {
  item: Recommendation;
  refetch: () => void;
};

export const RecommendationCard = ({
  item,
  refetch,
}: RecommendationCardProps) => {
  return (
    <Card className="p-4 flex flex-col gap-3">
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs font-medium text-zinc-500 uppercase">
          Symptômes ({item.symptoms.length})
        </p>
        <div className="flex gap-1 shrink-0">
          <EditRecommendation item={item} refetch={refetch} />
          <DeleteRecommendation item={item} refetch={refetch} />
        </div>
      </div>

      <div className="flex flex-wrap gap-1">
        {item.symptoms.map((s) => (
          <span
            key={s.id}
            className="text-xs bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full"
          >
            {s.symptom.type}
          </span>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-2">
        <div>
          <p className="text-xs font-medium text-zinc-500 uppercase mb-0.5">
            Texte (FR)
          </p>
          <p className="text-sm line-clamp-2">{item.textFr}</p>
        </div>
        <div>
          <p className="text-xs font-medium text-zinc-500 uppercase mb-0.5">
            Texte (EN)
          </p>
          <p className="text-sm line-clamp-2">{item.textEn}</p>
        </div>
        <div>
          <p className="text-xs font-medium text-zinc-500 uppercase mb-0.5">
            Pourquoi (FR)
          </p>
          <p className="text-sm line-clamp-2">{item.whyFr}</p>
        </div>
        <div>
          <p className="text-xs font-medium text-zinc-500 uppercase mb-0.5">
            Pourquoi (EN)
          </p>
          <p className="text-sm line-clamp-2">{item.whyEn}</p>
        </div>
      </div>
    </Card>
  );
};
